import * as _ from 'underscore';
import { Messages } from '../../codegen/Localize';
import { AlertErrorCode } from '../helpers/ErrorCodes';
import { IDataSourceInfo } from '../models/IDataSourceInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { DataSources } from '../resources/Datasources';
import { ICheckConnectionResult } from '../ServerApi/requests/CheckConnectionRequest';
import { IResult } from '../ServerApi/types/IResponse';
import { AbstractContentAction } from './AbstractContentAction';
import { ConfirmActionDialog, IConfirmActionDialogOptions } from './ConfirmActionDialog';
import { ContentActionNotification, INotificationTranslationIds } from './ContentActionNotification';

export class ChangeExtractDsToLiveAction extends AbstractContentAction<IDataSourceInfo> {

  public static $inject = ['ConfirmActionDialog', 'ContentActionNotification', '$translate', 'DataSources'];

  constructor(
            ConfirmActionDialog: ConfirmActionDialog,
            ContentActionNotification: ContentActionNotification,
    private $translate: ng.translate.ITranslateService,
    private Datasources: DataSources
  ) {
    super(ConfirmActionDialog, ContentActionNotification);
  }

  configureDialog(dialogConfig: IConfirmActionDialogOptions, dataSources: Set<IDataSourceInfo>) {

    const datasource = dataSources.first();
    const dataSourceIdArray = dataSources.map(ds => ds.id);
    dialogConfig.bodyText = Messages.changeExtractDsToLiveBody();
    dialogConfig.title = Messages.changeExtractDsToLive();
    dialogConfig.actionName = Messages.changeExtractDsToLiveConfirm();
    let workbookId = datasource.workbook != null ? datasource.workbook.id : '';
    const dataSourcesToCheck = dataSources.filter((datasource) => datasource.dataConnectionsCount === 1);
    dialogConfig.action = async () => {
      if (dataSourcesToCheck.size() > 0) {
        const results: ICheckConnectionResult[] = await this.Datasources.checkConnections(dataSourcesToCheck);
        if (!_.all(results, result=>result.succeeded)) {
          const fialedCheckConection: IResult = {errors:[]};
          dataSourcesToCheck.each(() => {
            fialedCheckConection.errors.push({code:AlertErrorCode.AlertConnectionlessFailure, message:'connection test failed'});
          });
          return Q.when(fialedCheckConection) as ng.IPromise<IResult>;
        }
      }
      return this.Datasources.changeToLive(dataSourceIdArray, workbookId);
    };
  }

  notificationTranslationIds(): INotificationTranslationIds {
    return {
      successId: 'changeExtractDsToLiveSuccess',
      errorId: 'changeExtractDsToLiveError'
    };
  }

}


Module.instance().service('ChangeExtractDsToLiveAction', ChangeExtractDsToLiveAction);
